// Memoized availability of static audio files. A URL is "available" when a
// HEAD request returns ok. Used to show only the sounds whose files exist.
const cache = new Map<string, boolean>();

async function probe(url: string, fetchFn: typeof fetch): Promise<boolean> {
  if (cache.has(url)) return cache.get(url)!;
  let ok = false;
  try {
    const res = await fetchFn(url, { method: 'HEAD' });
    const ct = res.headers?.get('content-type') || '';
    ok = res.ok && !ct.includes('text/html');
  } catch {
    ok = false;
  }
  cache.set(url, ok);
  return ok;
}

export async function checkAvailable(
  urls: string[],
  fetchFn: typeof fetch = fetch
): Promise<Set<string>> {
  const unique = Array.from(new Set(urls));
  const results = await Promise.all(unique.map((u) => probe(u, fetchFn).then((ok) => [u, ok] as const)));
  return new Set(results.filter(([, ok]) => ok).map(([u]) => u));
}
